import { LocationOn } from "@mui/icons-material";
import { Box, Paper, Rating, Typography } from "@mui/material";

function PropertyLocation(props) {
  const { data: property } = props;

  return (
    <>
      {/* <Paper elevation={0} sx={{ borderRadius: "8px" }}>
        <Box sx={{ mb: 6, textAlign: "center" }}>
          <Typography variant="h3" component="h1" gutterBottom>
            {property.title}
          </Typography>
          <Typography variant="h6" color="text.secondary" gutterBottom>
            {property.location}, {property.city}, {property.country}
          </Typography>
          <Box
            sx={{
              display: "flex",
              justifyContent: "center",
              alignItems: "center",
              mt: 2,
            }}
          >
            <Rating
              name="read-only"
              value={property.rating}
              readOnly
              precision={0.5}
            />
            <Typography variant="body2" color="text.secondary" sx={{ ml: 1 }}>
              (128 reviews)
            </Typography>
          </Box>
        </Box>
      </Paper> */}

      <Box>
        <Typography
          variant="h5"
          component="h2"
          sx={{ display: "flex", alignItems: "center", gap: 1 }}
        >
          {/* {property.location}, {property.city}, {property.country} */}
          <LocationOn color="action" /> Location
        </Typography>
        <Typography variant="h6" component="p" color="text.secondary">
          {/* {property.propertyType} */}
          {/* {property.location}, {property.city}, {property.country} */}
          {property.address.area}, {property.address.city.name},{" "}
          {property.address.state.name}
        </Typography>
      </Box>
    </>
  );
}

export default PropertyLocation;
